export const getTestCallParticipantVideo = (path: string): HTMLVideoElement => {
  const videoEl = document.createElement('video');
  videoEl.src = path;
  videoEl.loop = true;
  videoEl.autoplay = true;
  videoEl.muted = false;
  videoEl.playsInline = true;
  void videoEl.play().catch(() => {});
  return videoEl;
};
